import React, { useState, useEffect } from 'react';
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import { Box, Chip, Typography, Collapse, ListItem, makeStyles, Button, CircularProgress } from "@material-ui/core";
import SelectBoxInterval from '../common/select-box-interval';
import DateTimePicker from '../common/date-time-picker';
import ClusterFilter from './ClusterFilter';
import Checkbox from '../checkbox';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import CustomTextField from '../users/CustomTextField';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import colors from '../CustomizedUIs/Colors';
import { Alert } from '@material-ui/lab';
import { getTemplateInterval } from '../utils';
import { lightBlue, grey } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    container: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(2.5),
        marginRight: theme.spacing(2.5),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        backgroundColor: colors.white['50'],
        borderWidth: 1,
        borderColor: colors.lightBlue['200'],
        borderRadius: 4
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    titleRadio: {
        fontFamily: "UniviaPro-Medium",
        fontSize: 11,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
    },
    disabled: {
        cursor: 'pointer',
        borderBottomColor: grey['900'],
        pointerEvents: 'none',
        opacity: 0.4
    },
    root: {
        cursor: 'pointer',
        borderBottomColor: lightBlue['100']
    },
}));

const fakeData = [
    { id: 1, checked: false, name: 'Server Up-Time' },
    { id: 2, checked: false, name: 'Server Down-Time' },
    { id: 3, checked: false, name: 'TV Usage' },
    { id: 4, checked: false, name: 'Language selection' },
    { id: 5, checked: false, name: 'Time Channel' },
    { id: 6, checked: false, name: 'Messages/Alarms' },
    { id: 7, checked: false, name: 'Info Page' },
]

const Configuration = () => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const { permissions, loaded } = usePermissions();
    const classes = useStyles()
    const [loading, setLoading] = useState(false)
    const [selectedRecurrence, setSelectedRecurrence] = useState(null);
    const [dateSchedule, setDateSchedule] = useState(new Date());
    const [dateExpiration, setDateExpiration] = useState(new Date());
    const [entities, setEntities] = useState([]);
    const [listSection, setListSection] = useState(fakeData);
    const [openListSection, setOpenListSection] = useState(false)
    const [openPoper, setOpenPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [textValue, setTextValue] = React.useState({
        email: ''
    });
    const [validate, setValidate] = React.useState({
        email: {
            isError: true,
            message: ''
        },
    });
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const textOnChange = prop => (e) => {
        setTextValue({ [prop]: e.target.value })
        validateEmail(prop, e.target.value)
    }

    const validateEmail = (prop, value) => {
        if (value.length === 0)
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: 'required'
                } : {
                        isError: false, message: ''
                    }
            })
        else {
            setValidate({
                ...validate, [prop]: ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(value)) === true ? {
                    isError: false, message: ''
                } : {
                        isError: true, message: translate('pos.auth.errorEmail')
                    }
            })

        }
    }

    const handleOpenListSection = () => {
        setOpenListSection(!openListSection)
    }

    const onChangeCheckBox = (index) => {
        let temps = listSection.slice()
        temps[index].checked = temps[index].checked !== undefined ? !temps[index].checked : true
        setListSection(temps)
    }

    const onChangeRecurrence = (value) => {
        if (value.name === 'None')
            setSelectedRecurrence(null)
        else
            setSelectedRecurrence(value)
    }

    const getCluster = (selectedIds) => {
        setLoading(true)
        dataProvider('GET_ONE', "users/getclusterfilter",
            {
                id: JSON.parse(localStorage.getItem('userData')).user.id
            }
        ).then(({ data }) => {
            if(selectedIds && selectedIds.length > 0){
                selectedIds.forEach(s => {
                    data.levels.forEach(dl => {
                        dl.groups.forEach(dlg =>{
                           dlg.clusters.forEach(dlgc => {
                               if(dlgc.id === s)
                                   dlgc.checked = true;
                           });
                        });
                    })
                });

                selectedIds.forEach(s => {
                    data.levels.forEach(dl => {
                        dl.groups.forEach(dlg =>{
                            dlg.checked = dlg.clusters.every(dlgc => dlgc.checked);
                        });
                    })
                });

                selectedIds.forEach(s => {
                    data.levels.forEach(dl => {
                        dl.checked = dl.groups.every(dlg => dlg.checked);
                    })
                });
            }
            setEntities(data.levels);
            setLoading(false);
        }).catch(error => {
            console.error(error)
            setLoading(false);
        });
    }

    const getConfig = () => {
        setLoading(true)
        dataProvider('GET_ONE', "report"
        ).then(({ data }) => {
            if (data) {
                setTextValue({ email: data.email })
                setDateSchedule(new Date(data.schedule))
                setDateExpiration(new Date(data.expiration))
                setSelectedRecurrence(getTemplateInterval(data.interval))
                const clusterIds = [];
                const selectedClusters = JSON.parse(data.cluster);
                selectedClusters.forEach(selectedCluster => {
                    selectedCluster.groups.forEach(group => {
                        group.clusters.forEach(cluster => {
                            cluster.checked && clusterIds.push(cluster.id)
                        })
                    })
                })
                // setEntities(JSON.parse(data.cluster))
                getCluster(clusterIds);
                const sectionIds = JSON.parse(data.section)
                sectionIds.map(sec => {
                    fakeData.map(item => {
                        if (item.name === sec) {
                            item.checked = true
                        }
                    })
                })
                setListSection(fakeData)
                setLoading(false);
            }
            else {
                getCluster()
                const userData = JSON.parse(localStorage.getItem('userData'))
                setTextValue({ email: userData.user.email })
            }
        }).catch(error => {
            console.error(error)
            setLoading(false);
        });
    }

    const autoHideErrorMessage = () => {
        setTimeout(() => {
            setErrorMsg('');
        }, 6000);
    }

    const onSave = () => {
        let clusterIds = []
        entities.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    cluster.checked && clusterIds.push(cluster.id)
                })
            })
        })
        let sectionArray = []
        listSection.forEach(item => {
            item.checked && sectionArray.push(item.name)
        })
        if (new Date(dateExpiration) < new Date(dateSchedule)) {
            setErrorMsg(translate(`pos.messages.errorExpiration`));
            window.scrollTo(0, 0);
            autoHideErrorMessage();
        }
        else if (clusterIds.length <= 0) {
            setErrorMsg(translate(`pos.usageData.emptyCluster`));
            window.scrollTo(0, 0);
            autoHideErrorMessage();
        }
        else if (sectionArray.length <= 0) {
            setErrorMsg(translate(`pos.usageData.emptySection`));
            window.scrollTo(0, 0);
            autoHideErrorMessage();
        }
        else {
            setLoading(true);
            dataProvider('CREATE', 'report', {
                data: {
                    schedule: dateSchedule.getTime(),
                    expiration: dateExpiration.getTime(),
                    interval: selectedRecurrence ? selectedRecurrence.value : 'none',
                    cluster: JSON.stringify(entities),
                    section: JSON.stringify(sectionArray),
                    email: textValue.email
                }
            }).then(() => {
                setLoading(false)
            }).catch(response => {
                setLoading(false);
                setErrorMsg(translate(response.message))
                window.scrollTo(0, 0);
                autoHideErrorMessage();
            });
        }
    }

    const disableSaveButton = () => {
        if (!textValue.email) return true;
        if (!selectedRecurrence) return true
        return false;
    }

    useEffect(() => {
        getConfig()
    }, [])

    if (loading) return <Loading />
    if (!loaded) return null
    return (
        <Box className={!permissions.functionAction.find(value => value.function === 'Usage data' && value.isUpdate) ? classes.disabled : classes.root} mt={2}>
            <Collapse in={errorMsg.length > 0}>
                <Alert severity="error">{errorMsg}</Alert>
            </Collapse>
            <SelectBoxInterval
                open={true}
                recurrence={selectedRecurrence}
                onSelect={onChangeRecurrence}
                configuration={true}
            />
            <Box className={classes.container}>
                <Typography className={classes.titleRadio} style={{ marginLeft: 16 }}>Choose schedule time for report</Typography>
                <DateTimePicker
                    open={true}
                    date={dateSchedule}
                    setDate={setDateSchedule}
                    minDate={new Date()}
                    title={translate(`resources.reviews.fields.date`)}
                />
            </Box>
            <Box className={classes.container}>
                <Typography className={classes.titleRadio} style={{ marginLeft: 16 }}>Choose expiration time for report</Typography>
                <DateTimePicker
                    open={true}
                    date={dateExpiration}
                    setDate={setDateExpiration}
                    minDate={new Date()}
                    title={translate(`resources.reviews.fields.date`)}
                />
            </Box>
            <Box className={classes.container} width={590} ml={1} bgcolor='#F5F7FB' p={2} maxHeight={600} style={{ overflow: 'auto' }} borderRadius={4}>
                <Typography className={classes.titleRadio}>Choose cluster</Typography>
                <ClusterFilter hideSearch={true} entities={entities} setEntities={setEntities} />
            </Box>
            <Box width={622} my={2} bgcolor='#F5F7FB' ml={2.5}>
                <SelectBox
                    label={"Section"}
                    value={
                        !listSection || listSection.filter(element => element.checked).length === 0 ? '' :
                            <Box display='flex'>
                                {
                                    listSection.filter((element) => element.checked).map((data, index) => {
                                        if (index < 5)
                                            return (
                                                <Chip
                                                    color='primary'
                                                    size='small'
                                                    style={{ marginRight: 8 }}
                                                    key={data.id}
                                                    label={data.name}
                                                />
                                            )
                                    }
                                    )

                                }
                                {
                                    listSection.filter((element, index) => element.checked).length > 5 && <Typography variant='body1'>{translate(`pos.channels.more`)}</Typography>
                                }

                            </Box>
                    }
                    open={openListSection}
                    handleClick={handleOpenListSection}
                >
                    {
                        listSection.map((data, index) => (
                            <ListItem onClick={() => onChangeCheckBox(index)} key={'item-' + index} style={{ padding: '8px' }} button className={classes.boxBoder}>
                                <Checkbox color='primary' checked={data.checked === undefined ? false : data.checked}></Checkbox>
                                <Typography className={classes.TextValue}>{data.name}</Typography>
                            </ListItem>
                        ))
                    }

                </SelectBox>
            </Box>
            <Box mt={4} mx={2.5}>
                <CustomTextField
                    required
                    onBlur={() => {
                        validateEmail('email', textValue.email)
                    }}
                    id="filled-basic"
                    label={'Email'}
                    value={textValue.email}
                    error={validate.email.message != "" && validate.email.isError}
                    helperText={validate.email.message}
                    onChange={textOnChange('email')}
                    style={{ width: '100%' }}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={translate(`pos.user.TitleEmail`)}
                        content={translate(`pos.user.ConstentEmail`)}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box width='100%' display='flex' justifyContent='flex-end' my={2}>
                <Button
                    disabled={disableSaveButton()}
                    style={{ maxWidth: 40, marginRight: 20 }}
                    onClick={onSave}
                    variant="contained" color='primary' size='large'>
                    {loading ? (
                        <CircularProgress
                            size={20}
                            thickness={2}
                            color='inherit'
                        />
                    ) : translate('resources.room.save')}
                </Button>
            </Box>
        </Box>
    )
}
export default Configuration